import React from "react";
import {
  Box,
  makeStyles,
  ThemeProvider,
  Typography,
  Container,
} from "@material-ui/core";
import { theme } from "../constants/theme";
import { useTranslation } from "react-i18next";
export const Returns = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Box className={classes.container}>
      <ThemeProvider theme={theme}>
        <Container className={classes.root}>
          <Typography variant="h5" component="h5" color="textPrimary">
            {t('returns.title')}
          </Typography>
          <Container className={classes.content}>
            <div></div>
          </Container>
        </Container>
      </ThemeProvider>
    </Box>
  );
};
const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    flexGrow: 1,
    maxWidth: "840px",
  },
  content: {
    display: "flex",
    height: "100%",
    paddingLeft: 0,
    paddingRight: 0,
  },
});
